"use client";
import React, {
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react";
import { jointImgUploadByUser } from "@/lib/commonService";
import { getProductComment } from "@/src/models/review_es";
import { reviewPerPage } from "@/config/constConf";
import AnswerItem from "./AnswerItem";
import WithPhotoSwiper, {
    PhotoSwiperTitle,
    WrapperProps,
} from "@/src/components/Upload/WithPhotoSwiper";
import { FmViewList } from "@/ui-component";
import { useTranslation } from "@/src/i18n/client";
import { useCommonContext } from "@/src/provider";

interface IProps {
    id: number;
    userInfo: any;
}

const AnswerList: React.FC<WrapperProps<IProps>> = (props) => {
    const { mapPhotoSwiperImg, openSetPhotoSwiper, id } = props;
    const { lang } = useCommonContext();
    const [commentList, setCommentList] = useState<any[]>([]);
    const [pageLoading, setPageLoading] = useState(false);
    const [pagination, setPagination] = useState({
        total: 0,
        current_page: 1,
        per_page: reviewPerPage,
    });
    useEffect(() => {
        // 首次执行comment请求
        getComment();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getComment = useCallback(
        (page: number = 1) => {
            getProductComment(id, {
                type: 0,
                page,
                per_page: reviewPerPage,
            })
                .then((arg: any) => {
                    const { pagination, data } = arg;
                    setCommentList(data);
                    setPageLoading(false);
                    setPagination(pagination);
                })
                .catch((e: any) => {
                    console.log("评论列表获取失败", e);
                    setPageLoading(false);
                });
        },
        [id],
    );

    //评论后的无痕刷新
    const changeReplayInfo = useCallback(async () => {
        let getData: any = {
            type: 0,
            page: 1,
            per_page: commentList.length,
        };
        const result: any = await getProductComment(id, getData);

        setCommentList(result.data);
    }, [commentList.length, id]);

    const reviewList = useMemo(
        () =>
            commentList.map((item: any) => {
                return {
                    reviews_photo: item.reviews_photo
                        ? jointImgUploadByUser(item.reviews_photo)
                        : "",
                    title: PhotoSwiperTitle(item, true),
                };
            }),
        [commentList],
    );
    const imgs = useMemo(
        () => mapPhotoSwiperImg?.(reviewList, "reviews_photo"),
        [mapPhotoSwiperImg, reviewList],
    );

    return (
        <FmViewList
            onEndReached={(page) => {
                getComment(page);
            }}
            currentPage={pagination.current_page}
            total={pagination.total}
            pageSize={pagination.per_page}
        >
            {commentList.map((item: any, index: number) => (
                <AnswerItem
                    data={item}
                    key={index}
                    productId={id}
                    imgClick={openSetPhotoSwiper}
                    imgs={imgs}
                    isShowMore={true}
                    changeReplayInfo={changeReplayInfo}
                    userInfo={props.userInfo}
                    language={lang}
                />
            ))}
        </FmViewList>
    );
};

export default WithPhotoSwiper<IProps>(AnswerList)();
